import { Flex } from '@mantine/core';
import { Select, NumberInput } from 'react-hook-form-mantine';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon';
import { useTranslationCommonUi } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { Control, FieldValues, Path } from 'react-hook-form';

interface Props<T extends FieldValues> {
	inputName: Path<T>;
	selectName: Path<T>;
	selectPlaceholder?: string;
	disabled?: boolean;
	control: Control<T>;
	selectData: { label: string; value: string }[];
}

export const MixedTextDropdownInput = <T extends FieldValues>({
	inputName,
	selectName,
	selectData,
	selectPlaceholder,
	disabled,
	control,
}: Props<T>) => {
	const tCommonUI = useTranslationCommonUi();

	return (
		<Flex align="flex-start">
			<NumberInput
				name={inputName}
				control={control}
				size="md"
				hideControls
				disabled={disabled}
				sx={{
					flex: 1,
					'& input': {
						borderRight: 'none',
						borderTopRightRadius: 0,
						borderBottomRightRadius: 0,
					},
				}}
			/>
			<Select
				name={selectName}
				data={selectData}
				control={control}
				size="md"
				placeholder={selectPlaceholder || tCommonUI('common_placeholders.select')}
				rightSection={<Icon variant="caret-down" size="lg" />}
				rightSectionProps={{
					style: { pointerEvents: 'none' },
				}}
				sx={{
					flex: 1,
					'& input': {
						borderTopLeftRadius: 0,
						borderBottomLeftRadius: 0,

						'&:disabled': {
							borderTop: 'none',
							borderRight: 'none',
							borderBottom: 'none',
						},
					},
				}}
				disabled={disabled}
			/>
		</Flex>
	);
};
